<template>
    <div style="height: 100%; text-align: left">
        <el-row style="height: 100%" :gutter="20">
            <el-col :span="6" style="height: 100%">

                <div style="margin-bottom: 10px; display: flex; gap: 10px;">

                    <el-button type="success" size="small" @click="getRouteList">
                        刷新
                    </el-button>
                    <el-button type="primary" size="small" @click="setVehicleAutoRouteFileFTP">
                        设置
                    </el-button>

                </div>
                <div style="color:#FF0000;">
                    当下面没有数据时，请到‘运行工况数据编辑’菜单编辑数据并生成文件！
                </div>
                <el-table :data="routeList" style="width: 100%; cursor: pointer;" border height="calc(100% - 100px)"
                    max-height="calc(100% - 100px)" highlight-current-row>
                    <el-table-column prop="vFileID" label="线路ID" width="80"></el-table-column>
                    <el-table-column prop="vFlieName" label="线路名称" min-width="120"></el-table-column>
                    <!-- 操作列 -->
                    <el-table-column label="操作" width="80" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" @click="handleDetailClick(scope.row)">
                                详情
                            </el-button>

                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col :span="18" style="height: 100%">
                <div class="page_header">

                    <el-form :inline="true" size="small" style="flex:1;text-align: right;">
                        <el-form-item label="车号:">
                            <el-input clearable v-model="form.manufacturer" placeholder="请输入车号"></el-input>
                        </el-form-item>
                        <el-form-item label="车牌号:">
                            <el-input clearable v-model="form.vehicleNumber" placeholder="请输入车牌号"></el-input>
                        </el-form-item>
                        <el-form-item label="终端编号:">
                            <el-input clearable v-model="form.terminalNumber" placeholder="请输入终端编号"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="getSetHistory">{{ $t('public.query')
                            }}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="page_container">
                    <el-table :data="setList" size="small" style="width: 100%; cursor: pointer;" border
                        highlight-current-row>
                        <el-table-column prop="deviceNo" label="终端编号"></el-table-column>
                        <el-table-column prop="manufactureID" label="车号"></el-table-column>
                        <el-table-column prop="carNo" label="车牌号"></el-table-column>
                        <el-table-column prop="svFlieName" label="车台文件"></el-table-column>
                        <el-table-column prop="sBeginTime" label="车台设置时间"></el-table-column>
                        <el-table-column prop="svFileID" label="车台设置详情">
                            <template slot-scope="scope">
                                <el-button type="primary" size="mini"
                                    @click="handleDetailView(scope.row.svFileID)">详情</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="vFlieName" label="待下发文件"></el-table-column>
                        <el-table-column prop="setTime" label="待下发设置时间"></el-table-column>
                        <el-table-column prop="vFileID" label="待下发详情">
                            <template slot-scope="scope">
                                <el-button type="primary" size="mini"
                                    @click="handleDetailView(scope.row.vFileID)">详情</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="vID" label="登录历史">
                            <template slot-scope="scope">
                                <el-button type="primary" size="mini"
                                    @click="handleLoginHistoryView(scope.row)">查看</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="vID" label="下载历史">
                            <template slot-scope="scope">
                                <el-button type="primary" size="mini"
                                    @click="handleDownHistoryView(scope.row)">查看</el-button>
                            </template>
                        </el-table-column>

                    </el-table>

                </div>
            </el-col>
        </el-row>
        <!-- 登录历史,弹框，显示table -->
        <el-dialog title="登录历史" :visible.sync="dialogVisible" width="50%">
            <el-table :data="loginList" style="width: 100%; cursor: pointer;" border height="400px"
                highlight-current-row>
                <el-table-column prop="deviceNo" label="终端编号"></el-table-column>
                <el-table-column prop="loginTime" label="登录时间"></el-table-column>
            </el-table>
        </el-dialog>
        <!-- 下载历史,弹框，显示table -->
        <el-dialog title="下载历史" :visible.sync="dialogVisibleDown" width="50%">
            <el-table :data="downList" style="width: 100%; cursor: pointer;" border height="400px"
                highlight-current-row>
                <el-table-column prop="vFlieName" label="名称"></el-table-column>
                <el-table-column prop="versionNO" label="版本"></el-table-column>
                <el-table-column prop="endTime" label="升级时间"></el-table-column>
                <el-table-column prop="result" label="升级结果">
                    <template slot-scope="scope">
                        {{ scope.row.result === 0 ? '成功' : '失败' }}
                    </template>
                </el-table-column>

            </el-table>
        </el-dialog>
        <el-dialog title="线路详情" :visible.sync="dialogVisibleRoute" width="80%">
            <el-row :gutter="20">
                <el-col :span="8">

                    <!--线路信息-->

                    <el-descriptions title="线路信息">
                        <el-descriptions-item label="线路名称">{{ RouteName }}</el-descriptions-item>
                        <el-descriptions-item label="文件版本">{{ Version }}</el-descriptions-item>
                        <el-descriptions-item label="区域个数">{{ CityCount }}</el-descriptions-item>

                    </el-descriptions>

                    <!-- 区域列表 -->
                    <el-divider>线路区域列表</el-divider>
                    <div class="area-list-container" style="height: 400px;">
                        <AreaList ref="areaList" :map="dialogMap" :isEditModel="false" />
                    </div>


                </el-col>

                <!-- 右侧：地图 -->
                <el-col :span="16">
                    <div class="dialog-map-container">
                        <KingLongMap ref="dialogMap" mapId="area_dialog_map" @LoadCompleted="DialogMapLoadCompleted" />
                    </div>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>
<script>
import AreaList from "./components/area_list.vue";
import KingLongMap from "@/components/KingLongMap.vue";
import { GetLastFileUpLoadInfo808ByCompanyID, GetAutoRouteAreaListByVFileID, GetVehicleUpGradeRecFTPByVehicleID, GetVehicleLoginInfoByVehicleID, QueryVehicleVersionInfoFTP,SetVehicleAutoRouteFileFTP } from "@/http/vehicle.js";
export default {
    components: {
        KingLongMap, AreaList
    },
    data() {
        return {
            dialogMap: null,
            dialogVisibleRoute: false,
            dialogVisible: false,
            dialogVisibleDown: false,
            mapLoaded: false,
            total: 20,
            RouteName: '',
            Version: '',
            CityCount: '',
            form: {
                manufacturer: '',
                vehicleNumber: '',
                terminalNumber: '',
                PageNo: 1,
            },
            setList: [],
            downList: [],
            loginList: [
            ],
            routeList: [
            ],
            areaList: [],
        }
    },
    methods: {
        setVehicleAutoRouteFileFTP() {
            //选择车辆
            //选择文件
            SetVehicleAutoRouteFileFTP({
                vids:"156921",
                vFileID: 8710,
                vFileName:"4444"
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('设置成功');
                } else {
                    this.$message.error(res.msg || '设置失败');
                }
            })
        },
        handleLoginHistoryView(row) {
            this.dialogVisible = true;
            this.queryLoginInfo(row.vID);
        },
        handleDownHistoryView(row) {
            this.dialogVisibleDown = true;
            this.queryUpgradeRec(row.vID);
        },
        queryLoginInfo(vehicleID) {
            GetVehicleLoginInfoByVehicleID({
                vehicleID: vehicleID,
            }).then(res => {
                if (res.code === 200) {
                    this.loginList = res.data || [];
                }
            })
        },
        queryUpgradeRec(vehicleID) {
            GetVehicleUpGradeRecFTPByVehicleID({
                vehicleID: vehicleID,
                vFileType: 105,
            }).then(res => {
                if (res.code === 200) {
                    this.downList = res.data || [];
                }
            })
        },
        handleDetailClick(row) {
            this.handleDetailView(row.vFileID, row.vFlieName);

        },
        handleDetailView(vFileID, vFlieName) {
            vFileID = 8710
            this.dialogVisibleRoute = true;
            GetAutoRouteAreaListByVFileID({
                vFileID: vFileID,
            }).then(res => {
                if (res.code === 200) {

                    this.$nextTick(() => {
                        this.RouteName = vFlieName;
                        this.Version = res.data.areaInfo.version;
                        this.CityCount = res.data.areaInfo.areaCount;
                        if (this.mapLoaded) {
                            this.$refs.areaList.setAreaList(res.data.areaInfo.areaList || []);
                            this.areaList = [];
                        } else {
                            this.areaList = res.data.areaInfo.areaList || [];
                        }
                    })

                }
            })
        },
        DialogMapLoadCompleted() {
            this.dialogMap = this.$refs.dialogMap;
            this.mapLoaded = true;
            if (this.areaList.length > 0) {
                this.$nextTick(() => {

                    this.$refs.areaList.setAreaList(this.areaList || []);
                })
            }

        },
        pageChange(pageNo) {
            this.form.PageNo = pageNo;
        },
        getRouteList() {
            GetLastFileUpLoadInfo808ByCompanyID({
                companyID: 5356,
                vFileType: 105
            }).then(res => {
                if (res.code === 200) {
                    this.routeList = res.data || [];
                }
            })
        },
        getSetHistory() {
            QueryVehicleVersionInfoFTP({

            }).then(res => {
                if (res.code === 200) {
                    this.setList = res.data || [];
                }
            })
        },
    },
    mounted() {
        this.getRouteList();
        // this.queryLoginInfo();//测试

    }
}
</script>
<style scoped>
.dialog-map-container {
    width: 100%;
    height: 500px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.boc-adaptive-set {
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
}

.title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
}
</style>